@if ((selfRegisterOfflineContactActionState$ | async)?.done === false) {
  <div class="self-registration-wizard">
    <h1 class="title-xl">{{ 'self_registration.header_l' | translate }}</h1>
    <div class="self-registration-wizard__timer">
      <app-card
        class="timer d-flex flex-column align-items-center"
        [elevation]="3"
        [class.last-minute]="isLastMinute"
      >
        <p class="mb-0">
          {{ 'self_registration.cancel.countdown.text_l' | translate }}
        </p>
        <p class="countdown-time">
          {{
            timer$
              | async
              | appDateTime: { isCountdown: true, customPattern: 'HH:mm:ss' }
          }}
        </p>
      </app-card>
    </div>
    <app-wizard
      [steps]="allSteps"
      [currentStepNumber]="currentStepIndex + 1"
      [currentForm]="currentForm"
      [isProcessing]="(selfRegisterOfflineContactActionState$ | async)?.pending"
      [allowCancel]="true"
      [allowCancelInAnyStep]="true"
      [floatingTop]="false"
      [floatingActions]="false"
      [hideButtonContainer]="disableActions"
    >
      <app-internal-list-member-basic-information
        *appWizardStep="let change"
        [stepChange]="change"
        [steps]="allSteps"
        [hasOfflineUserAccess]="true"
        [housingPermissionTypes]="(constants$ | async)?.housingPermissionTypes"
        [isNewMember]="true"
        [form]="form.controls.memberInformation"
        [stepIndex]="getStepIndex('memberInformation')"
        [isSelfRegistration]="true"
        (onCancel)="cancelFlow()"
        (onSelectStep)="selectStep($event)"
        (onNextStep)="goToNextStep($event)"
      ></app-internal-list-member-basic-information>
      <app-internal-list-member-search-profile
        *appWizardStep="let change"
        [stepChange]="change"
        [steps]="allSteps"
        [formArray]="form.controls.searchProfiles"
        [isSelfRegistration]="true"
        [isOfflineUser]="true"
        [constants]="constants$ | async"
        [isNewContact]="true"
        [contactsDeletionConfig]="
          selfRegistrationConfig?.landlordCustomerContactsDeletionConfig
        "
        [(disableActions)]="disableActions"
        [(inviteToRegister)]="inviteToRegister"
        [stepIndex]="getStepIndex('searchProfiles')"
        [landlordCityPacket]="landlordCityPacket"
        [onlyShowConfiguredCityPartsToUser]="onlyShowConfiguredCityPartsToUser"
        [isRegistration]="true"
        [defaultObjectTypes]="selfRegistrationConfig?.defaultObjectTypes"
        (onCancel)="cancelFlow()"
        (onSelectStep)="selectStep($event)"
        (onPreviousStep)="goToPrevStep($event)"
        (onNextStep)="goToNextStep($event)"
      ></app-internal-list-member-search-profile>
      @if (showGlobalQuestions) {
        <app-global-custom-questions
          *appWizardStep="let change"
          [stepChange]="change"
          [steps]="allSteps"
          [stepIndex]="getStepIndex('globalCustomQuestions')"
          [form]="form.controls.globalCustomQuestions"
          [customQuestions]="
            selfRegistrationConfig?.questionsContainer?.customQuestions
          "
          [rootQuestions]="
            selfRegistrationConfig?.questionsContainer?.questions
          "
          (onCancel)="cancelFlow()"
          (onSelectStep)="selectStep($event)"
          (onPreviousStep)="goToPrevStep($event)"
          (onNextStep)="goToNextStep($event)"
        ></app-global-custom-questions>
      }
      <app-profile-dk-two
        *appWizardStep="let change"
        [stepChange]="change"
        [steps]="allSteps"
        [stepIndex]="getStepIndex('dkTwo')"
        [form]="form.controls.dkTwo"
        [employmentTypes]="(constants$ | async)?.employmentTypes"
        [householdTypes]="(constants$ | async)?.householdTypes"
        [showMoveInDate]="false"
        (onCancel)="cancelFlow()"
        (onSelectStep)="selectStep($event)"
        (onPreviousStep)="goToPrevStep($event)"
        (onComplete)="save()"
      >
      </app-profile-dk-two>
    </app-wizard>
  </div>
} @else {
  <app-application-confirmation
    [header]="'self_registration.outro_header_l'"
    [description]="'self_registration.outro_explanation_l'"
    [buttonText]="'self_registration.outro_redirect_to_intro_a'"
    (buttonClicked)="toIntroPage()"
  >
  </app-application-confirmation>
}
